/**
 * Escape text for dropping into printed HTML.
 *
 * Every printed document the shop produces is a template string with customer
 * text in it — a name, an address, a note asking for a loaf cut in half. All
 * of it was typed by somebody, so all of it goes through here: an ampersand in
 * a shop name or an angle bracket in a note would otherwise end the page early
 * and take the rest of the order with it.
 *
 * It lives in shared rather than beside one of the builders because there is
 * more than one builder, and two copies of an escaper is how one of them
 * quietly stops escaping something.
 */
export function escapeHtml(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
//# sourceMappingURL=html.js.map